module.exports = __webpack_public_path__ + "assets/images/client-8.ccb5f1e0.jpeg";